module.exports = __webpack_public_path__ + "static/assets/6916af8b3aa2a83574676b63a0398876.png";